// import moment from '@/plugins/moment';
import { toCamelCaseProperties } from '@fixit/utils';

export default class FavoriteProduct {
	constructor(args) {
		args = toCamelCaseProperties(args) || {};
		this.salon = args.salon || ''
		this.name = args.name || ''
		this.nameUrlSafe = args.nameUrlSafe || ''
		this.productIdBase64 = args.productIdBase64 || ''
		this.productId = args.productId || ''
		this.imageUrl = args.imageUrl || ''
		this.imageVersion = args.imageVersion || null
		this.brandName = args.brandName || ''
		this.chainId = args.chainId || null
		this.chainName = args.chainName || ''
		this.siteId = args.siteId || null
		this.siteName = args.siteName || ''
		this.siteNameUrlSafe = args.siteNameUrlSafe || ''
	}

	assign(product) {
		Object.assign(this, toCamelCaseProperties(product));
	}
}
